/**
 * Contains any youtube Iframe to a 16:9 frame if it's not already done
 */

(() => {
    const iframes = document.querySelectorAll(':not(.single-product, .ratio) iframe');

    if (iframes.length == 0) return;

    iframes.forEach((frame) => {
        if (!frame.src.includes('youtube')) return;

        let wrapper = document.createElement('div');
        wrapper.classList.add('ratio', 'ratio-16x9');

        frame.parentNode.insertBefore(wrapper, frame);

        wrapper.appendChild(frame);
    });
})();
